/*
 * ItemListPage Messages
 *
 * This contains all the text for the ItemListPage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  regularTotalPrice: {
    id: 'cwt.translations.ItemListPage.regularTotalPrice',
    defaultMessage: 'Regular Total',
  },
  defaultWorktopName: {
    id: 'cwt.translations.ItemListPage.defaultWorktopName',
    defaultMessage: 'Your custom worktop',
  },
  totalValue: {
    id: 'cwt.translations.ItemListPage.totalValue',
    defaultMessage: 'Total value of my selections',
  },  
  totalEcoFee: {
    id: 'cwt.translations.ItemListPage.totalEcoFee',
    defaultMessage: 'Dont Éco-Participation ',
  },
  summary: {
    id: 'cwt.translations.ItemListPage.summary',
    defaultMessage: 'Summary',
  },
  saveWorktop: {
    id: 'cwt.translations.ItemListPage.saveWorktop',
    defaultMessage: 'Save my selections',
  },
  worktop: {
    id: 'cwt.translations.ItemListPage.worktop',
    defaultMessage: 'Worktop',
  },
  washingArea: {
    id: 'cwt.translations.ItemListPage.washingArea',
    defaultMessage: 'Washing area',
  },
  wallPanels: {
    id: 'cwt.translations.ItemListPage.wallPanels',
    defaultMessage: 'Wall panels',
  },
  financingHelp: {
    id: 'cwt.translations.ItemListPage.financingHelp',
    defaultMessage: 'We can help with financing',
  },
  localDisclaimerTitle: {
    id: 'cwt.translations.ItemListPage.localDisclaimerTitle',
    defaultMessage: 'Terms and Conditions',
  },
  localDisclaimerText: {
    id: 'cwt.translations.ItemListPage.localDisclaimerText',
    defaultMessage: 'These general terms and conditions and the policies may change from time to time so please check these before making any purchase.\nWe try our best to make sure that all information on our website, including descriptions of our products and listed prices are accurate at all times. However, if we do make a mistake we’ll try to resolve it as soon as possible, and if we spot that an error has affected your order we’ll do our best to let you know.',
  },
  localFamilyPriceText: {
    id: 'cwt.translations.ItemListPage.localFamilyPriceText',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Extra text key to additionaly inform about the ikea family price, shown below the terms and conditions text',
    },
  },
  pricesAreEstimate: {
    id: 'cwt.translations.ItemListPage.pricesAreEstimate',
    defaultMessage: 'Prices are estimates',
  },
  financingHelpLink: {
    id: 'cwt.translations.ItemListPage.financingHelpLink',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Link to your local IKEA financing page, e.g. https://ikea.marat.qd.je/se/sv/customer-service/services/finance-options/',
    },
  },
  removeSelection: {
    id: 'cwt.translations.RemoveSelectionDialog.Description',
    defaultMessage: 'Do you want to remove this selection?',
  },
  editName: {
    id: 'cwt.translations.ItemListPage.EditName',
    defaultMessage: 'Edit name',
  },
  confirmName: {
    id: 'cwt.translations.ItemListPage.ConfirmName',
    defaultMessage: 'Confirm name',
  },
  startOver: {
    id: 'cwt.translations.ItemListPage.StartOver',
    defaultMessage: 'Start over',
  },
  additionalInfoTextEnabled: {
    id: 'cwt.translations.AdditionalInfoTextEnabled',
    defaultValue: false,
  },
  localFamilyPriceText: {
    id: 'cwt.translations.LocalFamilyPriceText',
    defaultValue: false,
  },
  additionalInfoHeadline: {
    id: 'cwt.translations.ItemListPage.AdditionalInfoHeadline',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Header for extra AdditionalInfoText, shown below the price on item list',
    },
  },
  additionalInfoText: {
    id: 'cwt.translations.ItemListPage.AdditionalInfoText',
    defaultMessage: '__EMPTY__',
    description: {
      allowEmpty: true,
      description: 'Extra information which will be shown below the price on item list',
    },
  },
  overhang: {
    id: 'cwt.translations.ItemListPage.Overhang',
    defaultMessage: 'overhang',
    description: 'Used to build a string like \'(with arc overhang)\'',
  },
  with: {
    id: 'cwt.translations.ItemListPage.WithOverhang',
    defaultMessage: 'with',
    description: 'Used to build a string like \'(with arc overhang)\'',
  }
});
